import { Component, Optional, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ButtonComponent } from '../botao/botao.component';

@Component({
  selector: 'app-modal-confirmacao',
  standalone: true,
  imports: [ButtonComponent, MatIconModule],
  templateUrl: './modal-confirmacao.component.html',
  styleUrl: './modal-confirmacao.component.css'
})
export class ModalConfirmacaoComponent {
  @Optional() private readonly data = inject(MAT_DIALOG_DATA, { optional: true }) ?? {};
  private readonly dialogRef = inject<MatDialogRef<ModalConfirmacaoComponent>>(MatDialogRef);

  titulo: string = this.data['titulo'] ?? 'Confirmação';
  texto: string = this.data['texto'] ?? 'Deseja realmente fechar?';
  labelCancelar: string = this.data['labelCancelar'] ?? 'Cancelar';
  labelConfirmar: string = this.data['labelConfirmar'] ?? 'Confirmar';

  cancelar() {
    this.dialogRef.close(false);
  }

  confirmar() {
    this.dialogRef.close(true);
  }
}
